import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Form, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaSearch, FaMapMarkerAlt } from 'react-icons/fa';
import './Community.css';

export default function LakeHub() {
  const [lakes, setLakes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchLakes = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/community/lakes`);
        const data = await res.json();
        if (data.success) {
          setLakes(data.lakes);
        }
      } catch (error) {
        console.error("Error fetching lakes", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchLakes();
  }, []);

  const filteredLakes = lakes.filter(lake => 
    lake.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    (lake.state && lake.state.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="community-container">
      <Container>
        <Row className="mb-5 align-items-center">
          <Col lg={8}>
            <h1 className="display-4 fw-bold text-white mb-3">Lake Intelligence</h1>
            <p className="lead text-muted">
              Discover top bass fishing lakes, find verified operators, track upcoming tournaments, 
              and join local discussions.
            </p>
          </Col>
        </Row>

        <Row className="mb-5">
          <Col lg={8}>
            <InputGroup size="lg" className="shadow">
              <Form.Control
                placeholder="Search lakes by name or state..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="bg-dark text-white border-secondary"
                style={{ borderRadius: '8px' }}
              />
              <InputGroup.Text className="bg-warning text-dark border-0" style={{ borderRadius: '0 8px 8px 0' }}>
                <FaSearch />
              </InputGroup.Text>
            </InputGroup>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="warning" />
          </div>
        ) : (
          <Row>
            {filteredLakes.length > 0 ? (
              filteredLakes.map(lake => (
                <Col md={6} lg={4} key={lake.id} className="mb-4">
                  <Link to={`/community/lakes/${lake.slug}`} className="text-decoration-none">
                    <div className="community-card clickable h-100 p-0 overflow-hidden">
                      <div 
                        className="bg-secondary" 
                        style={{ 
                          height: '160px', 
                          backgroundImage: `url(${lake.heroImage || 'https://via.placeholder.com/600x300?text=Lake'})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center'
                        }}
                      />
                      <div className="p-3">
                        <h4 className="text-white mb-1">{lake.name}</h4>
                        <div className="text-muted small mb-3">
                          <FaMapMarkerAlt className="me-1 text-warning" /> {lake.state || 'United States'}
                        </div>
                        <p className="text-muted small mb-0 text-truncate">
                          {lake.description || 'Join the community discussion for this lake.'}
                        </p>
                      </div>
                    </div>
                  </Link>
                </Col>
              ))
            ) : (
              <Col>
                <div className="community-card text-center py-5">
                  <h4 className="text-muted">No lakes found matching "{searchTerm}"</h4>
                  <p className="text-muted mb-0">Try a different search term.</p>
                </div>
              </Col>
            )}
          </Row>
        )}
      </Container>
    </div>
  );
}
